import { FC, useState } from 'react';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { faUserCircle } from '@fortawesome/free-regular-svg-icons';
import { RootState } from '../../../../store';
import { Modal } from '../../../ui';

type ISupportModalProps = {
  open: boolean;
  onClose: () => void;
};

const SupportModal: FC<ISupportModalProps> = ({ open, onClose }) => {
  const { crm_name, crm_contact_number } = useSelector(
    (state: RootState) => state.authentication.user
  );
  const [message, setMessage] = useState('');

  const handleSend = () => {
    if (!crm_contact_number || !message.trim()) return;
    const number = crm_contact_number.replace(/\D/g, '');
    window.open(`https://wa.me/${number}?text=${encodeURIComponent(message)}`, '_blank');
    setMessage('');
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose} title="Support" size={{ width: '560px' }}>
      <div className="p-6">
        <div className="flex items-center gap-4 pb-5 border-b border-gray-100">
          <FontAwesomeIcon icon={faUserCircle} className="text-teal-500" style={{ width: 40, height: 40 }} />
          <div className="flex-1">
            <p className="font-semibold text-gray-900">{crm_name || 'Not assigned yet'}</p>
            <p className="text-sm text-gray-500">
              {crm_contact_number ? crm_contact_number : 'Contact your Relationship Manager for help'}
            </p>
          </div>
          {crm_contact_number && (
            <a
              href={`tel:${crm_contact_number}`}
              className="flex items-center gap-1.5 bg-teal-500 hover:bg-teal-600 text-white text-sm font-semibold px-4 py-2 rounded-lg transition-colors shrink-0"
            >
              <FontAwesomeIcon icon={faPhone} /> Call
            </a>
          )}
        </div>

        <div className="pt-5">
          <label className="text-sm font-medium text-gray-700">Send a message</label>
          <textarea
            rows={5}
            maxLength={1000}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Type your message..."
            disabled={!crm_contact_number}
            className="w-full mt-2 border border-gray-200 rounded-xl px-4 py-3 text-sm text-gray-700 resize-none outline-none focus:ring-2 focus:ring-teal-300 focus:border-teal-400 disabled:bg-gray-50 disabled:cursor-not-allowed"
          />
          <div className="flex items-center justify-between mt-2">
            <span className="text-xs text-gray-400">{message.length}/1000</span>
            <button
              onClick={handleSend}
              disabled={!crm_contact_number || !message.trim()}
              className="flex items-center gap-1.5 px-5 py-2 text-sm font-semibold text-white bg-teal-500 rounded-lg hover:bg-teal-600 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
            >
              <FontAwesomeIcon icon={faPaperPlane} /> Send
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default SupportModal;
